import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {TurnazioneRecord} from "@commons/mapping/TurnazioneRecord";
import {FPNetDate, ObjectFactory, UserTrace} from "@commons/types";
import {TabellePresenze} from "@commons/mapping/TabellePresenze";
import {TurnoDistribuzioneRecord} from "@commons/mapping/TurnoDistribuzioneRecord";
import {merge} from "lodash";

export type TipoDescrizione = "MANUALE" | "AUTOMATICA_NO_FLEX" | "AUTOMATICA_SI_FLEX" | "AUTOMATICA";

export type TipoTurnazione = "MANUALE" | "AUTOMATICA";
export type TipologiaVoceTurno = '_BASE' | 'ALT_AUTO' | 'ALT_MANUALE' | '_CONSUNTIVO';

interface TurnoWeekTipoRecord {
}

export interface TurnoRecord extends URIAndTrace {
    idAziendaTabelle: number,
    codTurno: number,
    descrizione: string,
    ggRicorsivita: number,
    baseGiorniWeek: number,
    hhWeekMedie: number,
    hhWeekFullTime: number,
    hhWeekNominale: number,
    codGiuOLD: string,
    codGiuOLN: string,
    codGiuPausaD: string,
    codGiuPausaN: string,
    hhWeekMedieDistribuzione: number,
    tipoDescrizione: TipoDescrizione,
    tipoTurnazione: TipoTurnazione,
    descrizioneExport: string,
    turnoArchiviato: boolean,
    decorrenza: FPNetDate,
    fineValidita: FPNetDate,
    //weekTipo: TurnoWeekTipoRecord,
    indexWeek1: number,
    descWeek1: string,
    turnazioni: TurnazioneRecord[],
    distribuzione: TurnoDistribuzioneRecord[],
    tabelle: TabellePresenze | null,
    usaInPianificazione: boolean,
    insertTrace?: UserTrace,
    lastUpdateTrace?: UserTrace,
    tipologia: TipologiaVoceTurno | undefined,
}

export class TurnoRecord {

    static factory: ObjectFactory<TurnoRecord> = (json?) => {
        return merge<TurnoRecord, Partial<TurnoRecord> | undefined>({
            idAziendaTabelle: 0,
            codTurno: 0,
            descrizione: '',
            ggRicorsivita: 0,
            baseGiorniWeek: 0,
            hhWeekMedie: 0,
            hhWeekFullTime: 0,
            hhWeekNominale: 0,
            codGiuOLD: '',
            codGiuOLN: '',
            codGiuPausaD: '',
            codGiuPausaN: '',
            hhWeekMedieDistribuzione: 0,
            tipoDescrizione: "MANUALE",
            tipoTurnazione: "MANUALE",
            descrizioneExport: '',
            turnoArchiviato: false,
            decorrenza: null,
            fineValidita: null,
            //weekTipo: undefined,
            indexWeek1: 0,
            descWeek1: '',
            turnazioni: [],
            distribuzione: [],
            tabelle: null,
            usaInPianificazione: false,
            insertTrace: undefined,
            lastUpdateTrace: undefined,
            tipologia: '_BASE',
            URI: null,
        }, json);
    }

    /**
     * Restituisce una distribuzione oraria in base ai parametri indicati
     * @param that il turno
     * @param index l'indice della giornata
     * @param distribuzioneTurnoBase distribuzione da utilizzare nel caso turno senza previsto (es. smart working di Pizzato Elettrica)
     */
    static getDistribuzione = (that: TurnoRecord, index: number, distribuzioneTurnoBase?: TurnoDistribuzioneRecord) => {
        if (that.ggRicorsivita === 1 // turno alternativo
            && that.hhWeekMedie === 0 // senza previsto
            && distribuzioneTurnoBase) { // se alternativo senza previsto, prendo previsto da turno base! (Modalità per gestire lo smart working di Pizzato Elettrica)
            const newDistribuzione = TurnoDistribuzioneRecord.factory(distribuzioneTurnoBase);
            // Dalla distribuzione del turno alternativo (distribuzione[0]) prelevo tutte le impostazioni relative agli arrotondamenti
            const distribuzioneAlt = that.distribuzione[0];
            newDistribuzione.tipoArrotondamentoPausa = distribuzioneAlt.tipoArrotondamentoPausa;
            newDistribuzione.idTabArrotondamentiPausa = distribuzioneAlt.idTabArrotondamentiPausa;
            newDistribuzione.tabArrotondamentiPausa = distribuzioneAlt.tabArrotondamentiPausa;

            newDistribuzione.tipoArrotondamento = distribuzioneAlt.tipoArrotondamento;
            newDistribuzione.idTabArrotondamenti = distribuzioneAlt.idTabArrotondamenti;
            newDistribuzione.tabArrotondamenti = distribuzioneAlt.tabArrotondamenti;

            newDistribuzione.tipoArrotondamentoUscita = distribuzioneAlt.tipoArrotondamentoUscita;
            newDistribuzione.idTabArrotondamentiUscita = distribuzioneAlt.idTabArrotondamentiUscita;
            newDistribuzione.tabArrotondamentiUscita = distribuzioneAlt.tabArrotondamentiUscita;

            newDistribuzione.tipoArrotondamentoInfragiornaliero = distribuzioneAlt.tipoArrotondamentoInfragiornaliero;
            newDistribuzione.idTabArrotondamentiInfragiornaliero = distribuzioneAlt.idTabArrotondamentiInfragiornaliero;
            newDistribuzione.tabArrotondamentiInfragiornaliero = distribuzioneAlt.tabArrotondamentiInfragiornaliero;
            return newDistribuzione;
        } else {
            return (that.ggRicorsivita === 1) ? that.distribuzione[0] : that.distribuzione[index - 1];
        }
    }

    static compare = (a: TurnoRecord, b: TurnoRecord) => {
        if (a.hhWeekMedie === b.hhWeekMedie) {
            return a.descrizione!.localeCompare(b.descrizione!);
        } else return a.hhWeekMedie < b.hhWeekMedie ? -1 : 1;
    }
    static compareDescrizioneDistribuzione = (a: TurnoRecord, b: TurnoRecord) => {
        return a.distribuzione[0].descrizione!.localeCompare(b.distribuzione[0].descrizione!);
    }

}